import CancelIcon from "@mui/icons-material/Cancel";
import SearchIcon from "@mui/icons-material/Search";
import { InputAdornment, styled, TextField, Tooltip } from "@mui/material";
import {
  QuickFilter,
  QuickFilterClear,
  QuickFilterControl,
  QuickFilterTrigger,
  ToolbarButton,
} from "@mui/x-data-grid-premium";
import React from "react";
import CloseArrowTooltip from "../CloseArrowTooltip.tsx";

const StyledTextField = styled(TextField)<{
  open: boolean;
}>(({ theme, open }) => ({
  gridArea: "1 / 1",
  overflowX: "clip",
  width: open ? 260 : 0,
  opacity: open ? 1 : 0,
  transition: theme.transitions.create(["width", "opacity"]),
}));

const StyledToolbarButton = styled(ToolbarButton)<{ open: boolean }>(
  ({ theme, open }) => ({
    gridArea: "1 / 1",
    width: open ? 0 : "min-content",
    height: "min-content",
    zIndex: 1,
    opacity: open ? 0 : 1,
    pointerEvents: open ? "none" : "auto",
    transition: theme.transitions.create(["width", "opacity"]),
  }),
);

export default function DatagridQuickFilter({
  searchColumns = "",
  quickSearchTextFieldToolTip = "",
}: {
  searchColumns?: string;
  quickSearchTextFieldToolTip?: string;
}) {
  return (
    <QuickFilter debounceMs={600}>
      <QuickFilterTrigger
        render={(triggerProps, state) => (
          <Tooltip
            title={
              "Search" + (searchColumns ? " " + searchColumns : "") + "..."
            }
            enterDelay={0}
          >
            <StyledToolbarButton
              {...triggerProps}
              open={state.expanded}
              color="default"
              aria-disabled={state.expanded}
            >
              <SearchIcon fontSize="small" color="primary" />
            </StyledToolbarButton>
          </Tooltip>
        )}
      />
      <QuickFilterControl
        render={({ ref, ...controlProps }, state) => (
          <CloseArrowTooltip title={quickSearchTextFieldToolTip}>
            <StyledTextField
              {...controlProps}
              open={state.expanded}
              inputRef={ref}
              aria-label="Search"
              placeholder={
                "Search" + (searchColumns ? " " + searchColumns : "") + "..."
              }
              size="small"
              variant="standard"
              slotProps={{
                input: {
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon fontSize="small" color="primary" />
                    </InputAdornment>
                  ),
                  endAdornment: state.value ? (
                    <InputAdornment position="end">
                      <QuickFilterClear
                        edge="end"
                        size="small"
                        aria-label="Clear search"
                        material={{ sx: { marginRight: -0.75 } }}
                      >
                        <CancelIcon fontSize="small" color="primary" />
                      </QuickFilterClear>
                    </InputAdornment>
                  ) : null,
                  ...controlProps.slotProps?.input,
                },
                ...controlProps.slotProps,
              }}
            />
          </CloseArrowTooltip>
        )}
      />
    </QuickFilter>
  );
}
